enum SignedStatus {
  sentForSigning = 'Sent for signing',
  signedManually = 'Signed manually',
  signedWithDocuSign = 'Signed with DocuSign',
  allSigned = 'All signed',
}

export default SignedStatus;
export type VerifySignedStatus = Utils.VerifyExtends<Model.Enum.SignedStatus, Utils.ValueOf<typeof SignedStatus>>;
